export default "__VITE_ASSET__3372c9c7__"